import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FiInstagram, FiMail, FiMapPin, FiShield } from 'react-icons/fi';

function Footer() {
    const [cookiesHide, setCookiesHide] = useState(true);

    function handleAcceptCookies() {
        localStorage.setItem('cookiesHide', 'true');
        setCookiesHide(false);
    }

    function handleRejectCookies() {
        localStorage.setItem('cookiesHide', 'false');
        setCookiesHide(false);
    }

    useEffect(() => {
        const cookieState = localStorage.getItem('cookiesHide');
        if (cookieState !== null) {
            setCookiesHide(false);
        }
    }, []);

    const footerLinkStyle = {
        textDecoration: 'none',
        color: 'rgba(255,255,255,0.78)',
        fontSize: '0.96rem',
        lineHeight: 1.8,
        transition: 'all 0.25s ease'
    };

    const sectionTitleStyle = {
        fontSize: '1rem',
        fontWeight: 800,
        color: '#ffffff',
        marginBottom: '16px'
    };

    const smallTextStyle = {
        color: 'rgba(255,255,255,0.68)',
        lineHeight: 1.8,
        fontSize: '0.95rem'
    };

    return (
        <>
            <footer
                style={{
                    position: 'relative',
                    background: 'linear-gradient(180deg, #08172f 0%, #0a1d3d 100%)',
                    color: '#ffffff',
                    overflow: 'hidden',
                    marginTop: '0'
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        top: '-120px',
                        right: '-120px',
                        width: '280px',
                        height: '280px',
                        borderRadius: '50%',
                        background: 'radial-gradient(circle, rgba(214,160,74,0.14), transparent 70%)'
                    }}
                />

                <div
                    style={{
                        position: 'absolute',
                        bottom: '-140px',
                        left: '-140px',
                        width: '320px',
                        height: '320px',
                        borderRadius: '50%',
                        background: 'radial-gradient(circle, rgba(255,255,255,0.06), transparent 70%)'
                    }}
                />

                <div className="container" style={{ position: 'relative', zIndex: 2, padding: '72px 0 28px' }}>
                    <div className="row g-5">
                        <div className="col-lg-4">
                            <div style={{ maxWidth: '340px' }}>
                                <Link
                                    to="/"
                                    style={{
                                        display: 'inline-block',
                                        textDecoration: 'none',
                                        marginBottom: '22px'
                                    }}
                                >
                                    <img
                                        src="assets/images/logo-real-energy-121x45.png"
                                        alt="Logo RealEnergy"
                                        style={{
                                            width: '160px',
                                            height: 'auto',
                                            filter: 'brightness(0) invert(1)'
                                        }}
                                    />
                                </Link>

                                <p style={smallTextStyle}>
                                    A RealEnergy atua com soluções em energia, infraestrutura, operação e serviços
                                    especializados, com foco em qualidade, segurança e compromisso institucional.
                                </p>

                                <div style={{ display: 'grid', gap: '10px', marginTop: '20px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'rgba(255,255,255,0.74)' }}>
                                        <FiShield size={16} />
                                        <span style={{ fontSize: '0.94rem' }}>Ética, transparência e responsabilidade</span>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'rgba(255,255,255,0.74)' }}>
                                        <FiMail size={16} />
                                        <span style={{ fontSize: '0.94rem' }}>contato@realenergy.com.br</span>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'rgba(255,255,255,0.74)' }}>
                                        <FiMapPin size={16} />
                                        <span style={{ fontSize: '0.94rem' }}>Atuação em diferentes regiões do Brasil</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-6 col-md-4 col-lg-2">
                            <div style={sectionTitleStyle}>Institucional</div>
                            <div style={{ display: 'grid', gap: '8px' }}>
                                <motion.div whileHover={{ x: 4 }}>
                                    <Link to="/about" style={footerLinkStyle}>Quem Somos</Link>
                                </motion.div>
                                <motion.div whileHover={{ x: 4 }}>
                                    <Link to="/servicos" style={footerLinkStyle}>Serviços</Link>
                                </motion.div>
                                <motion.div whileHover={{ x: 4 }}>
                                    <Link to="/transparencia" style={footerLinkStyle}>Transparência</Link>
                                </motion.div>
                                <motion.div whileHover={{ x: 4 }}>
                                    <Link to="/etica" style={footerLinkStyle}>Compliance</Link>
                                </motion.div>
                            </div>
                        </div>

                        <div className="col-6 col-md-4 col-lg-3">
                            <div style={sectionTitleStyle}>Relacionamento</div>
                            <div style={{ display: 'grid', gap: '8px' }}>
                                <motion.div whileHover={{ x: 4 }}>
                                    <Link to="/contato" style={footerLinkStyle}>Contato</Link>
                                </motion.div>
                                <motion.div whileHover={{ x: 4 }}>
                                    <Link to="/denuncia" style={footerLinkStyle}>Denúncias</Link>
                                </motion.div>
                                <motion.div whileHover={{ x: 4 }}>
                                    <Link to="/fornecedor" style={footerLinkStyle}>Pré-Cadastro de Fornecedor</Link>
                                </motion.div>
                                <motion.div whileHover={{ x: 4 }}>
                                    <Link to="/trabalheconosco" style={footerLinkStyle}>Trabalhe Conosco</Link>
                                </motion.div>
                            </div>
                        </div>

                        <div className="col-md-4 col-lg-3">
                            <div style={sectionTitleStyle}>Políticas</div>
                            <div style={{ display: 'grid', gap: '8px', marginBottom: '20px' }}>
                                <motion.div whileHover={{ x: 4 }}>
                                    <Link to="/etica" style={footerLinkStyle}>Termos de Uso</Link>
                                </motion.div>
                                <motion.div whileHover={{ x: 4 }}>
                                    <Link to="/etica" style={footerLinkStyle}>Política de Privacidade</Link>
                                </motion.div>
                                <motion.div whileHover={{ x: 4 }}>
                                    <Link to="/etica" style={footerLinkStyle}>Política de Cookies</Link>
                                </motion.div>
                            </div>

                            <div style={sectionTitleStyle}>Redes sociais</div>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                <motion.a
                                    whileHover={{ y: -4, scale: 1.04 }}
                                    whileTap={{ scale: 0.98 }}
                                    href="https://instagram.com/energyreal"
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                        width: '46px',
                                        height: '46px',
                                        borderRadius: '14px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        textDecoration: 'none',
                                        background: 'rgba(255,255,255,0.08)',
                                        border: '1px solid rgba(255,255,255,0.10)',
                                        color: '#ffffff'
                                    }}
                                >
                                    <FiInstagram size={18} />
                                </motion.a>
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            marginTop: '42px',
                            paddingTop: '22px',
                            borderTop: '1px solid rgba(255,255,255,0.10)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: '16px',
                            flexWrap: 'wrap'
                        }}
                    >
                        <p
                            style={{
                                margin: 0,
                                color: 'rgba(255,255,255,0.62)',
                                fontSize: '0.92rem'
                            }}
                        >
                            © Copyright 2026-2027 REALENERGY. Todos os direitos reservados.
                        </p>

                        <p
                            style={{
                                margin: 0,
                                color: 'rgba(255,255,255,0.52)',
                                fontSize: '0.9rem'
                            }}
                        >
                            Desenvolvido com foco em experiência, clareza e presença institucional.
                        </p>
                    </div>
                </div>
            </footer>

            <AnimatePresence>
                {cookiesHide && (
                    <motion.div
                        id="cb-cookie-banner"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.28 }}
                        style={{
                            position: 'fixed',
                            left: '24px',
                            right: '24px',
                            bottom: '24px',
                            zIndex: 9999,
                            maxWidth: '1120px',
                            margin: '0 auto',
                            background: 'rgba(255,255,255,0.96)',
                            backdropFilter: 'blur(16px)',
                            WebkitBackdropFilter: 'blur(16px)',
                            border: '1px solid rgba(13, 46, 99, 0.08)',
                            borderRadius: '24px',
                            boxShadow: '0 24px 60px rgba(15, 23, 42, 0.16)',
                            padding: '20px 22px'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: '18px',
                                flexWrap: 'wrap'
                            }}
                        >
                            <div style={{ flex: '1 1 620px' }}>
                                <div
                                    style={{
                                        fontWeight: 800,
                                        color: '#0d2e63',
                                        marginBottom: '8px',
                                        fontSize: '1rem'
                                    }}
                                >
                                    🍪 Política de cookies
                                </div>

                                <p
                                    style={{
                                        margin: 0,
                                        color: '#607089',
                                        lineHeight: 1.8,
                                        fontSize: '0.95rem'
                                    }}
                                >
                                    Utilizamos cookies para melhorar sua experiência de navegação, entender o uso do site e oferecer conteúdos mais relevantes.
                                    Ao continuar, você concorda com essa utilização. Consulte nossa{' '}
                                    <Link
                                        to="/etica"
                                        style={{
                                            color: '#0d4fb3',
                                            textDecoration: 'none',
                                            fontWeight: 700
                                        }}
                                    >
                                        Política de Privacidade
                                    </Link>
                                    .
                                </p>
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    gap: '12px',
                                    flexWrap: 'wrap',
                                    alignItems: 'center'
                                }}
                            >
                                <motion.button
                                    whileHover={{ y: -2, scale: 1.01 }}
                                    whileTap={{ scale: 0.98 }}
                                    type="button"
                                    onClick={handleAcceptCookies}
                                    style={{
                                        border: 'none',
                                        borderRadius: '14px',
                                        padding: '13px 18px',
                                        background: 'linear-gradient(135deg, #0d4fb3, #0a3d91)',
                                        color: '#ffffff',
                                        fontWeight: 700,
                                        boxShadow: '0 16px 32px rgba(13, 79, 179, 0.18)'
                                    }}
                                >
                                    Prosseguir
                                </motion.button>

                                <motion.button
                                    whileHover={{ y: -2, scale: 1.01 }}
                                    whileTap={{ scale: 0.98 }}
                                    type="button"
                                    onClick={handleRejectCookies}
                                    style={{
                                        border: '1px solid rgba(13, 46, 99, 0.10)',
                                        borderRadius: '14px',
                                        padding: '13px 18px',
                                        background: '#f8fbff',
                                        color: '#0d2e63',
                                        fontWeight: 700
                                    }}
                                >
                                    Rejeitar
                                </motion.button>
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}

export default Footer;